export const API_CONFIG = {
  BASE_URL: 'https://api.idcoder.in/api',
  //BASE_URL: 'https://localhost:7055/api',
  /** Sent as X-App-Brand so emails use the IDCoder sender name. */
  APP_BRAND: 'idcoder',
} as const;

export const API_PATHS = {
  enrollments: {
    enroll: '/Enrollments/course/enroll',
    byUser: (userProfileId: number) => `/Enrollments/user/${userProfileId}`,
    byCourse: (courseId: number) => `/Enrollments/course/${courseId}`,
    status: (enrollmentId: number) => `/Enrollments/${enrollmentId}/status`,
    sendInvite: '/Enrollments/send-invite',
  },
  courses: {
    list: '/programs',
    byId: (id: number) => `/programs/${id}`,
    byIds: '/programs/by-ids',
    create: '/programs/create',
    update: (id: number) => `/programs/update/${id}`,
    delete: (id: number) => `/programs/delete/${id}`,
    deletePermanent: (id: number) => `/programs/delete/${id}?permanent=true`,
    enrollmentCounts: '/programs/enrollment-counts',
  },
  userProfile: {
    byIds: '/UserProfile/by-ids',
  },
  interviews: {
    config: '/Interviews/config',
    request: '/Interviews/request',
    byUser: (userProfileId: number) => `/Interviews/user/${userProfileId}`,
    assigned: '/Interviews/assigned',
    reports: '/Interviews/reports',
    byId: (interviewRequestId: number) => `/Interviews/${interviewRequestId}`,
    list: '/Interviews',
    adminCreate: '/Interviews/admin',
    schedule: (interviewRequestId: number) => `/Interviews/${interviewRequestId}/schedule`,
    assign: (interviewRequestId: number) => `/Interviews/${interviewRequestId}/assign`,
    reject: (interviewRequestId: number) => `/Interviews/${interviewRequestId}/reject`,
    acceptInterest: (interviewRequestId: number) => `/Interviews/${interviewRequestId}/accept-interest`,
    feedback: (interviewRequestId: number) => `/Interviews/${interviewRequestId}/feedback`,
    delete: (interviewRequestId: number) => `/Interviews/${interviewRequestId}`,
  },
  mentor: {
    register: '/Mentor/register',
    verifyEmail: '/Mentor/verifyemail',
    resendVerification: (email: string) => `/Mentor/resendverification/${encodeURIComponent(email)}`,
  },
  interviewer: {
    register: '/Interviewer/register',
    verifyEmail: '/Interviewer/verifyemail',
    resendVerification: (email: string) => `/Interviewer/resendverification/${encodeURIComponent(email)}`,
    list: '/Interviewer',
  },
  inquiries: {
    create: '/Inquiries/create',
    list: '/Inquiries',
  },
  notifications: {
    send: '/Email/send',
    list: '/EmailNotifications',
    retrigger: (id: number) => `/EmailNotifications/${id}/retrigger`,
  },
} as const;

export function apiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${API_CONFIG.BASE_URL}${normalized}`;
}

export function apiHeaders(token?: string | null, extra?: Record<string, string>): HeadersInit {
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'X-App-Brand': API_CONFIG.APP_BRAND,
    ...extra,
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}
